import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const BUDGET_URL = `${backendUrl}/api/budget/`;

class BudgetService {
	async getAllBudgets() {
		try {
			const response = await axios.get(BUDGET_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getBudget(id) {
		return axios.get(`${BUDGET_URL}${id}/`);
	}

	createBudget(data) {
		return axios.post(BUDGET_URL, data).catch((error) => {
			console.error('Erreur lors de la création du budget', error);
			throw error;
		});
	}

	updateBudget(id, data) {
		return axios.put(`${BUDGET_URL}${id}/`, data);
	}

	deleteBudget(id) {
		return axios.delete(`${BUDGET_URL}${id}/`);
	}

	getBudgetOptions() {
		return this.getAllBudgets().then((budgets) => {
			const options = budgets.map((budget) => ({
				value: budget.id,
				label: budget.categorie.toUpperCase()
			}));
			return options;
		});
	}
}

export default new BudgetService();
